import React, { PureComponent } from "react";
import Typography from "@material-ui/core/Typography";
import MenuItem from "@material-ui/core/MenuItem";
import Checkbox from "@material-ui/core/Checkbox";
import ListItemText from "@material-ui/core/ListItemText";
import { MyPATDropdown, MyPATSelect } from "../../common";
import goalManagementService from "../services/goalManagementService";
import CustomInfoIcon from "../../common/CustomInfoIcon";
import { Grid } from "@material-ui/core";

export interface CareerType {
  _id: string;
  name: string;
  isSelected?: boolean;
}

interface OnChangeHandlerProps {
  selectedCareerIds: string[];
  removedCareerIds: string[];
}

interface Props {
  onChange: (props: OnChangeHandlerProps) => void;
  errorText?: string;
  classes: any;
  disabled: boolean;
  courseTypeId?: string;
}

interface State extends OnChangeHandlerProps {
  allCareerTypes: CareerType[];
}

class CareerTypeField extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      allCareerTypes: [],
      selectedCareerIds: [],
      removedCareerIds: [],
    };
  }
  findRemovedCareerTypes = ({
    all,
    newSelected,
  }: {
    all: CareerType[];
    newSelected: string[];
  }) => {
    return all.reduce((acc: string[], career) => {
      const { _id, isSelected } = career;
      if (isSelected && !newSelected.includes(_id)) {
        acc.push(_id);
      }
      return acc;
    }, []);
  };

  passCareerTypesToOnChangeHandler = () => {
    const { allCareerTypes: unused, ...rest } = this.state;
    this.props.onChange(rest);
  };

  handleSelectionChange = (selectedIds: string[]) => {
    
    this.setState(
      (currentState) => ({
        ...currentState,
        selectedCareerIds: selectedIds,
        removedCareerIds: this.findRemovedCareerTypes({
          all: currentState.allCareerTypes,
          newSelected: selectedIds,
        }),
      }),
      this.passCareerTypesToOnChangeHandler
    );
  };
  componentDidMount() {
    // fetch careers and set state
    const { courseTypeId } = this.props;
    goalManagementService.getCareerTypes({ params: { courseTypeId } }).then((data: CareerType[]) => {
      const selectedCareerIds = data
        .filter(({ isSelected }) => isSelected)
        .map(({ _id }) => _id);
      this.setState(
        {
          allCareerTypes: data,
          selectedCareerIds,
        },
        this.passCareerTypesToOnChangeHandler
      );
    });
  }
  renderer = () => {
    const { allCareerTypes, selectedCareerIds } = this.state;
    return allCareerTypes
      .reduce((acc: string[], { _id, name }) => {
        if (selectedCareerIds.includes(_id)) {
          acc.push(name);
        }
        return acc;
      }, [])
      .join(", ");
  };

  render() {
    const { classes, disabled, errorText } = this.props;
    const { allCareerTypes, selectedCareerIds } = this.state;
    return (
      <>
        <Typography variant="body1" gutterBottom className={[classes.fontSizeMD, classes.labelText].join(' ')}>
          Career Type
          <span className={classes.iconStyle}>
          <CustomInfoIcon
											infoDialogContentType="Goal Management"
                      isInfoIcon={true}
                      isRightArrow={false}
                      isCenterArrow={true}
                      knowMoreAbout={false}
                      dialogTitle="Career Type"
                      imageURL="/assets/svg/careerType.svg"
                      dialogPara=""
                      details="Click to know more"
                      toolTipDirection="top"
                      htmlElement={
                        <>
                          <Grid container justify="flex-start">
                            <Typography style={{marginLeft:30,marginBottom:12,}}>While onboarding, student needs to select the goal based on his/her career selection. This feature allows user to map goal with different career options</Typography>
                          </Grid>
                        </>
                      }/>
                      </span>
        </Typography>
        <MyPATDropdown 
          placeholder="Select Career"
          dropdownItems={allCareerTypes}
          selectedItem = {selectedCareerIds}
          onChange={this.handleSelectionChange}
          labelKey="name"
          valueKey="_id"
          multiple
          error={!!errorText}
          errorText={errorText}
          disabled={disabled}
          isCustomCss={true}
          />
        {/* <MyPATSelect
          multiple={true}
          isNative={false}
          fullWidthControl
          required
          onChange={this.handleSelectionChange}
          inputId="careerType"
          name="careerType"
          error={!!errorText}
          errorText={errorText}
          disabled={disabled}
          value={selectedCareerIds}
          displayEmpty
          customRenderFunc={this.renderer}
          placeholder={
            <Typography
              variant="body2"
              align="left"
              inline
              className={classes.greyText}
            >
              Select career
            </Typography>
          }
        >
          {allCareerTypes.map(({ _id, name }) => (
            <MenuItem key={_id} value={_id}>
              <Checkbox
                color="primary"
                checked={selectedCareerIds.includes(_id)}
              />
              <ListItemText primary={name} />
            </MenuItem>
          ))}
        </MyPATSelect> */}
      </>
    );
  }
}

export default CareerTypeField;
